module.exports = __webpack_public_path__ + "static/img/newLoad_zhiyuan1.e50b6ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/download/newLoad_zhiyuan1.png
// module id = CNIH
// module chunks = 3